import { c as _c } from "react/compiler-runtime";
import { Heading, HStack, IconButton, Progress, Stack } from '@chakra-ui/react';
import { CardCarouselControlProps } from '@src/components/sco/CardCarousel/Controls/CardCarouselControlProps';
import { ArrowLeftIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export const TopControl = props => {
  const $ = _c(10);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue(["column", "column", "column", "row"]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.title) {
    t1 = props.title && <>{typeof props.title === "string" ? <Heading>{props.title}</Heading> : props.title}</>;
    $[2] = props.title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props) {
    t2 = props.pages.length >= 1 ? <HStack align="center" gap={0} justify="center"><IconButton _hover={{
        opacity: 1
      }} opacity="0.5" size="xs" title="Previous Page" variant="unstyled" aria-label="Previous Page" onClick={() => props.prevPage()}><ArrowLeftIcon /></IconButton><IconButton _hover={{
        opacity: 1
      }} opacity="0.5" size="lg" title="Previous Item" variant="unstyled" aria-label="Previous Item" onClick={() => props.prevItem()}><ChevronLeftIcon /></IconButton><Progress.Root borderRadius="1em" colorPalette="blue" flexGrow={1} size="xs" value={props.pagesPercent === 100 ? 100 : Math.max(10, props.itemsPercent)} width="200px" css={{
        "& > div": {
          transition: "all 150ms"
        }
      }}><Progress.Track><Progress.Range /></Progress.Track></Progress.Root><IconButton _hover={{
        opacity: 1
      }} opacity="0.5" size="lg" title="Next Item" variant="unstyled" aria-label="Next Item" onClick={() => props.nextItem()}><ChevronRightIcon /></IconButton><IconButton _hover={{
        opacity: 1
      }} opacity="0.5" size="xs" title="Next Page" variant="unstyled" aria-label="Next Page" onClick={() => props.nextPage()}><ArrowRightIcon /></IconButton></HStack> : <div />;
    $[4] = props;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <Stack align="center" direction={t0} justify="space-between" marginY="1em">{t1}{t2}</Stack>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};